import { forwardRef } from 'react';
import { Field, FieldProps, getIn } from 'formik';
import { JItem } from '../jformik/jformik.types';
// import { useBreakpointQuery } from '../../../utils';
// import moment from 'moment'
// import { useJFormikContext } from '../jformik/jformik.context';
import { DateRangesInput } from '../../date-ranges-coordination-input';
import { FormHelperText } from '@mui/material';
import {
  DateRange,
  DateRangeItem,
  DateRanges,
} from '../../date-ranges-coordination-input/DateRangesInput.context';
import { useJFormikContext } from '../jformik/jformik.context';

export const FDateRangePicker = forwardRef((jItem: JItem, ref) => {
  const { name } = jItem;
  // const smDown = useBreakpointQuery('sm-down');
  const { disabled = false } = useJFormikContext();
  return (
    <Field name={name} ref={ref}>
      {({
        field: { name, value },
        form: { touched, errors, submitCount, setFieldValue }, // also values, setXXXX, handleXXXX, dirty, isValid, status, etc.
        meta,
      }: FieldProps) => {
        let formattedDateValues: DateRanges = {
          default:
            value?.['default']?.map((range: DateRangeItem) => {
              let formattedRange = { ...range };
              if (typeof formattedRange.start === 'string') {
                formattedRange.start = new Date(formattedRange.start);
              }
              if (typeof formattedRange.end === 'string') {
                formattedRange.end = new Date(formattedRange.end);
              }
              return formattedRange;
            }) || [],
          reply:
            value?.['reply']?.map((range: DateRangeItem) => {
              let formattedRange = { ...range };
              if (typeof formattedRange.start === 'string') {
                formattedRange.start = new Date(formattedRange.start);
              }
              if (typeof formattedRange.end === 'string') {
                formattedRange.end = new Date(formattedRange.end);
              }
              return formattedRange;
            }) || [],
          suggest:
            value?.['suggest']?.map((range: DateRangeItem) => {
              let formattedRange = { ...range };
              if (typeof formattedRange.start === 'string') {
                formattedRange.start = new Date(formattedRange.start);
              }
              if (typeof formattedRange.end === 'string') {
                formattedRange.end = new Date(formattedRange.end);
              }
              return formattedRange;
            }) || [],
        };
        return (
          <DateRangesInput
            disabled={jItem.disabled || disabled}
            single={jItem?.jItemProps?.single}
            columns={jItem?.jItemProps?.columns}
            dateRangePickerPanelProps={
              jItem?.jItemProps?.dateRangePickerPanelProps
            }
            dateRanges={formattedDateValues}
            events={jItem?.jItemProps?.events || []}
            filters={jItem?.jItemProps?.filters || []}
            reply={jItem?.jItemProps?.reply}
            onChange={(range, ranges) => {
              setFieldValue(name, ranges);
            }}
          />
        );
      }}
    </Field>
  );
});
